import {  Heading, Pane, SideSheet,Position, Link, Dialog } from 'evergreen-ui'
// import { Position } from 'evergreen-ui/types'
import React from 'react'
import Logo from './../../../assets/logo.svg'
import { SidebarListItem, SidebarListItemIconContainer, SidebarListItemRow } from './SidebarWidget.style'

import homeIcon from './../../../assets/home.png'
// import propertyIcon from './../../../assets/property.png'
import duesIcon from './../../../assets/dues.png'
import residentIcon from './../../../assets/residents.png'
// import guestIcon from './../../../assets/guest.png'
// import complaintsIcon from './../../../assets/complaints.png'
// import filesIcon from './../../../assets/dues.png'
import communicationIcon from './../../../assets/complaints.png'
// import reportsIcon from './../../../assets/reports.png'
import bankIntegrationIcon from './../../../assets/property.png'
import settingsIcon from './../../../assets/settings.png'
// import securityIcon from './../../../assets/security.png'
// import paymentIcon from './../../../assets/payment.png'
import logoutIcon from './../../../assets/logout.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '../../../context/AuthContext';
import Cookies from 'js-cookie'

export default function MobileSidebarMenu() {
    const [isShown, setIsShown] = React.useState(false)
    // const [selectedIndex, setSelectedIndex] = React.useState(0)
    const history = useHistory()
const managerType = Cookies.get('managerType');

    return (
        <div>
        <SideSheet
          isShown={isShown}
          onCloseComplete={() => setIsShown(false)}
          position={Position.LEFT}
          width={"80%"}
          containerProps={{
            display: 'flex',
            flex: '1',
            flexDirection: 'column'
          }}
        >
          <Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
            <Pane padding={16} borderBottom="muted">
              <Heading size={600}>
                <Link to="/" className="brand-logo p-16 black-text">
                    {/* Dashboard */}
                    <div className='' style={{
                        marginLeft:"10px"
                    }}>
                        <img src={Logo} alt=''/>
                    </div>
                </Link>
              </Heading>
            </Pane>
          </Pane>
          <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                <Link to='/dashboard' onClick={()=>history.push("/dashboard")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={homeIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Home
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to='/property' onClick={()=>history.push("/property")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                {/* <img src={propertyIcon} alt='' /> */}
                                <img src={duesIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Units
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to='/owner' onClick={()=>history.push("/owner")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                {/* <img src={propertyIcon} alt='' /> */}
                                <img src={duesIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Owner
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to='/resident' onClick={()=>history.push("/resident")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={residentIcon} alt='' width='20px' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Resident
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>

                <Link to='/dues' onClick={()=>history.push("/dues")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={duesIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Dues
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to='/complaint' onClick={()=>history.push("/complaint")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={duesIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Complaints
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                <Link to="/communication" onClick={()=>history.push("/communication")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={communicationIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Communication
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>

                <Link to="/security" onClick={()=>history.push("/security")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={communicationIcon} alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Security Men
                        </SidebarListItem>
                    </SidebarListItemRow>
                </Link>
                {managerType !=="sub" &&
                    <Link to='/banks' onClick={()=>history.push("/banks")}>
                    <SidebarListItemRow>
                        <SidebarListItemIconContainer>
                            <center>
                                <img src={bankIntegrationIcon} width="20px" alt='' />
                            </center>
                        </SidebarListItemIconContainer>
                        <SidebarListItem >
                            Bank Integration
                        </SidebarListItem>
                    </SidebarListItemRow>
                    </Link>
                }
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <Link to='/settings' onClick={()=>history.push("/settings")}>
                <SidebarListItemRow>
                    <SidebarListItemIconContainer>
                        <center>
                            <img src={settingsIcon} alt='' />
                        </center>
                    </SidebarListItemIconContainer>
                    <SidebarListItem >
                        Settings
                    </SidebarListItem>
                </SidebarListItemRow>
                </Link>
                
                <LogoutBtn />
          </Pane>
        </SideSheet>
        <div 
            onClick={() => setIsShown(true)}
            marginRight={16} style={{
                // border:"2px dashed red",
                width:"40px"
            }}
            >
                <i className="material-icons black-text center">menu</i>
            </div>
        </div>
    )
  }





  function LogoutBtn() {
    const [isShown, setIsShown] = React.useState(false)
    const history = useHistory()
    const {logout,refresh} = useAuth()
    const clearAllCookies = () => {
        const cookies = Object.keys(Cookies.get());
        cookies.forEach(cookie => Cookies.remove(cookie));
      };
    
    const logoutUser =(e)=>{
        // e.preventDefault()
        logout();
        clearAllCookies()
        Cookies.remove('userAccessToken');
        refresh();
        history.push(`/`);
    
    }
      return (
        <Pane>
          <Dialog
            isShown={isShown}
            title="Log out"
            intent="danger"
            onCloseComplete={() => setIsShown(false)}
            confirmLabel="Logout"
            onConfirm={()=>{
                console.log("sad")
                logoutUser()
            }}
            shouldCloseOnOverlayClick={false}
          >
            Are you sure you want to Logout?
          </Dialog>
    
            {/* <Button >Show Dialog</Button> */}
            <SidebarListItemRow onClick={() => setIsShown(true)} >
                <SidebarListItemIconContainer>
                    <center>
                        <img src={logoutIcon} alt='' />
                    </center>
                </SidebarListItemIconContainer>
                <SidebarListItem >
                    Logout
                </SidebarListItem>
            </SidebarListItemRow>
        </Pane>
      )
    }
    